import { ReactFlowProvider } from "reactflow";
import type { MachineDetail } from "@/features/lines/hooks";
import type { CanvasNode } from "@opus-dt/shared-types";
import type { LineCanvas } from "@/types/canvas.types";
import { CanvasInner } from "./CanvasInner";

export type CanvasMode = "display" | "edit";

export interface ProductionLineCanvasProps {
  lineId: string;
  mode?: CanvasMode;
  onMachineClick?: (m: MachineDetail) => void;
  height?: number | string;
  compact?: boolean;
  hideMiniMap?: boolean;
  isRunning?: boolean;
  onSaved?: () => void;
  onCancel?: () => void;
  onOpenSidebar?: (node: CanvasNode, options?: { canvasAdd?: boolean }) => void;
  pendingMachineAssignment?: { nodeId: string; machineId: string; name: string } | null;
  onAssignmentApplied?: () => void;
  saveLabel?: string;
  onSaveOverride?: () => Promise<void>;
  onBeforeSave?: () => Promise<void>;
  externalCanSave?: boolean;
  onCreateNewMachine?: (basic: {
    name: string;
    code: string;
    type: "MACHINE" | "EQUIPMENT" | "HUMAN";
  }) => void;
  pendingMachineAdd?: { id: string; name: string } | null;
  onMachineAddApplied?: () => void;
  /**
   * Publica o canvas EM EDIÇÃO para quem valida acima na árvore (o painel de pendências do editor).
   *
   * Opcional porque este canvas também é usado em telas sem painel — detalhe da linha e ambiente.
   */
  onEditCanvasChange?: (canvas: LineCanvas) => void;
}

export function ProductionLineCanvas(props: ProductionLineCanvasProps) {
  return (
    <ReactFlowProvider>
      <CanvasInner {...props} />
    </ReactFlowProvider>
  );
}

export default ProductionLineCanvas;
